<template>
  <div
    class="notifications-orders"
    @mouseenter="toggleDropdown(true)"
    @mouseleave="toggleDropdown(false)"
  >
    <a
      class="notifications-orders__link icon"
      href="/account/orders"
      @click="onWidgetClick"
    >
      <f-sprite-icon :icon-link="IconBox" />
      <ui-badge
        :text="orders?.length"
        color="#f34744"
        :loading="isLoading"
      />
    </a>

    <ui-dropdown
      :visible="isDropdownShow"
      overlay-height="40"
      class="notifications-orders__dropdown"
    >
      <ui-loader
        v-if="isLoading"
        class="notifications-orders__loader"
        size="60"
      />
      <page-info
        v-if="!isLoading && !orders?.length"
        class="notifications-orders__empty"
        :subtitle="`Пока нет оформленных<br>заказов. <a href='${startLink}'>Начать покупки</a>`"
      />
      <template v-else>
        <notifications-orders-item
          v-for="order in orders"
          :key="order.orderNumber"
          class="notifications-orders__item"
          :created-at="order.createdAt"
          :number="order.orderNumber"
          :products-count="order.quantity"
          :status="order.currentStatus"
          :is-waiting-prepay="!!order.isWaitingPrepay"
          :receiving-method="order.receivingMethod"
          :external-delivery-name="order.externalDeliveryName"
          :address="order.address"
          :receiving-date-from="order.receivingDateFrom"
          :receiving-date-to="order.receivingDateTo"
          :storage-period="order.storagePeriod"
          :delivery-time="order.deliveryTime"
          @prepay-timer-end="onPrepayTimerEnd"
          @click="onClickOrder(order.orderNumber)"
        />
      </template>
    </ui-dropdown>
  </div>
</template>

<script lang="ts">
import {
  computed, defineComponent, inject,
  ref,
} from 'vue';

export default defineComponent({
  name: 'notifications-orders',
});
</script>

<script setup lang="ts">
import { debounce } from 'throttle-debounce';
import { useStore } from 'vuex';

import IconBox from '@/assets/icons/box.svg';
import PageInfo from '@/components/common/page-info.vue';
import { headerGtmEvents } from '@/gtm/header-gtm-events';

import NotificationsOrdersItem from './notifications-orders-item.vue';

const adaptive = inject('adaptive');

const $order = inject('$order');

const store = useStore();

const isDropdownShow = ref<boolean>(false);

const account = computed(() => store.getters['user/account']);

const orders = computed<unknown[]>(() => store.getters['orders/ordersForNotifications']);

const isLoading = computed<boolean>(() => store.getters['orders/loadNotificationsProgress']);

const startLink = computed<string>(() => {
  switch (account.value.gender) {
    case 'male': {
      return '/catalog/muzhchiny';
    }
    case 'female': {
      return '/catalog/zhenschiny/';
    }
    default: {
      return '/catalog/sale/';
    }
  }
});

const toggleDropdown = (value: boolean): void => {
  if (adaptive.isDesktop) {
    isDropdownShow.value = value;
  }
};

const onPrepayTimerEnd = debounce(1000, () => store.dispatch('orders/fetchOrdersForNotifications'));
const onWidgetClick = () => {
  headerGtmEvents.clickWidgetOrders();
};
const onClickOrder = (orderNumber: string): void => {
  $order.show(orderNumber, 'online');
  headerGtmEvents.clickWidgetOrder();
};
</script>

<style lang="scss">
.notifications-orders {
  position: relative;

  & .ui-dropdown {
    padding: 8px 0;
    top: 40px;
    width: 360px;
    left: -180px;
    margin-left: 50%;
  }

  & &__link {
    display: inline-block;
  }

  & &__item {
    cursor: pointer;
    border-bottom: 1px solid #e0e0e0;

    &:last-of-type {
      border-bottom: 0;
    }
  }

  & &__dropdown {
    .ui-dropdown-scrollview {
      overflow-y: hidden;
    }
  }

  & &__empty {
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    text-align: center;
    margin-top: 40px;
    margin-bottom: 48px;
  }

  & &__loader {
    position: absolute;
    top: calc(50% - 30px);
    left: calc(50% - 30px);
    color: $blue;
  }
}
</style>
